import { theme } from 'src/shared/styles/common/themes/theme';
import { themeBW } from 'src/shared/styles/common/themes/themeBW';
import { Theme } from '@mui/material';

export const themes: { [key: string]: Theme } = {
	default: theme,
	bw: themeBW,
};
